// Mock data for Nora Gold Advisory website

export const companyInfo = {
  name: "Nora Gold Advisory",
  tagline: "Strategic Business | Financial & Investment Advisory",
  heroTitle: "Building Bankable Businesses. Unlocking Sustainable Capital.",
  heroDescription: "Nora Gold Advisory is an Africa-based advisory firm providing strategic business, financial analytics, and investment advisory services to SMEs, corporates, investors, and development partners across emerging and frontier markets.",
  heroSubDescription: "We help organizations strengthen commercial performance, make data-driven decisions, and access sustainable financing for growth. Our approach combines deep analytical expertise with hands-on advisory support throughout the full business lifecycle.",
  ctaPrimary: "Speak to an Advisor",
  ctaSecondary: "Explore Our Services"
};

export const aboutUs = {
  title: "About Us",
  paragraphs: [
    "Nora Gold Advisory is a professional advisory firm headquartered in Accra, Ghana. We support SMEs, corporates, project sponsors, and institutions to move from strategy to execution by combining rigorous analysis with practical, market-driven solutions.",
    "Our work spans business development advisory, financial and data analytics, and access to finance consulting. We partner closely with clients across the full business lifecycle—from early-stage structuring and growth to investment readiness, financing, and expansion.",
    "The firm is led by a multidisciplinary team of experienced business strategists, financial analysts, and investment advisors with strong backgrounds in private sector development, development finance, and transaction advisory. Our approach is hands-on, collaborative, and focused on delivering implementable outcomes.",
    "Nora Gold Advisory support clients in agribusiness, energy, manufacturing, and development-driven sectors."
  ]
};

export const visionMission = {
  vision: {
    title: "Our Vision",
    content: "To be a trusted advisory partner driving sustainable business growth, investment readiness, and value creation across emerging and frontier markets."
  },
  mission: {
    title: "Our Mission",
    content: "To deliver high-quality business, financial, and investment advisory services that enable clients to make informed decisions, build bankable enterprises, and access the capital required for long-term growth."
  }
};

export const services = [
  {
    id: 1,
    title: "Business Development Advisory",
    description: "We support clients with growth strategy, market entry, business structuring, and partnership development to strengthen competitiveness and scale operations.",
    icon: "TrendingUp"
  },
  {
    id: 2,
    title: "Data & Financial Analytics",
    description: "We provide financial modeling, forecasting, valuation, performance diagnostics, and data-driven insights to support strategic and investment decisions.",
    icon: "BarChart3"
  },
  {
    id: 3,
    title: "Access to Finance Advisory",
    description: "We assist businesses to structure bankable projects, prepare investment-ready documentation, and engage effectively with commercial banks, DFIs, investors, and grant providers.",
    icon: "Landmark"
  },
  {
    id: 4,
    title: "Grant & Donor Advisory",
    description: "We support grant strategy, proposal development, capital mobilization, and reporting for local and international donor-funded programs.",
    icon: "HandCoins"
  },
  {
    id: 5,
    title: "Policy, Institutional & Development Advisory",
    description: "We deliver policy assessments, institutional diagnostics, market systems advisory, and M&E frameworks for development programs and public institutions.",
    icon: "Building2"
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Experienced Advisory Team",
    description: "We bring strong expertise in business strategy, financial analytics, and investment advisory, backed by practical, transaction-oriented experience.",
    icon: "Users"
  },
  {
    id: 2,
    title: "Hands-On, End-to-End Support",
    description: "We work closely with clients across the entire business lifecycle—strategy, growth, financing, and expansion—providing continuous guidance, not one-off advice.",
    icon: "Handshake"
  },
  {
    id: 3,
    title: "Client-Centric Partnership",
    description: "We grow with our clients, remaining engaged as their needs evolve and ensuring solutions are practical, implementable, and investment-ready.",
    icon: "Heart"
  },
  {
    id: 4,
    title: "Market-Driven Solutions",
    description: "Our advisory approach is grounded in local and regional market realities, ensuring credibility with financiers and development partners.",
    icon: "Globe"
  }
];

export const expertise = [
  "Business strategy and growth advisory",
  "Financial modeling and analytics",
  "Investment readiness and transaction advisory",
  "Access to finance and grant mobilization",
  "Policy and institutional advisory",
  "Monitoring, evaluation, and performance analytics"
];

export const portfolioHighlights = [
  {
    id: 1,
    stat: "€45M+",
    description: "Grant and investment capital mobilized, including large-scale donor facilities and private investment initiatives."
  },
  {
    id: 2,
    stat: "$35M+",
    description: "Transaction and investment advisory for multi-million projects across agribusiness, energy, and manufacturing."
  },
  {
    id: 3,
    stat: "20+",
    description: "SME support institutions and development programs supported with financial products, policy frameworks, and performance systems."
  },
  {
    id: 4,
    stat: "2+",
    description: "Countries with advisory assignments delivered—Ghana and Rwanda—working with development partners, financial institutions, and private sector clients."
  }
];

export const clientTypes = [
  { id: 1, name: "Small and Medium Enterprises (SMEs)", icon: "Store" },
  { id: 2, name: "Corporates and Project Sponsors", icon: "Building" },
  { id: 3, name: "Financial Institutions and Investors", icon: "Landmark" },
  { id: 4, name: "Development Finance Institutions (DFIs)", icon: "CircleDollarSign" },
  { id: 5, name: "Donors, NGOs, and Public Sector Institutions", icon: "Globe2" }
];

export const contactInfo = {
  companyName: "Nora Gold Advisory",
  building: "YOTA Building",
  street: "95 La-Bawaleshie Road",
  area: "East Legon, Accra, Ghana",
  digitalAddress: "G4-448-1116",
  postalAddress: "PMB CT400, Cantonments, Accra – Ghana",
  email: "contact@noragoldadvisory.com",
  phone: "+233 24 802 0872"
};

export const navLinks = [
  { id: 1, label: "About", href: "#about" },
  { id: 2, label: "Services", href: "#services" },
  { id: 3, label: "Why Us", href: "#why-us" },
  { id: 4, label: "Portfolio", href: "#portfolio" },
  { id: 5, label: "Contact", href: "#contact" }
];
